import { FC } from "react";

import { Stack, StackProps } from "@mui/material";

import { DashboardIcon } from "@/dashboard-design-system/Icon/DashboardIcon";
import { DashboardSwitch } from "@/dashboard-design-system/Switch";
import { Desktop, Mobile } from "@/icons/outlined";

type MobileDesktopSwitchProps = Omit<
  StackProps,
  "direction" | "alignItems" | "justifyContent" | "gap" | "onChange" | "children"
> & {
  onChange: (value: "desktop" | "mobile", event: React.ChangeEvent<HTMLInputElement>) => void;
  value: "desktop" | "mobile";
};

export const MobileDesktopSwitch: FC<MobileDesktopSwitchProps> = ({ onChange, value, ...rest }) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="center" gap={2} {...rest}>
      <DashboardIcon size="large" vibe="text-neutral-quiet">
        <Mobile />
      </DashboardIcon>
      <DashboardSwitch
        checked={value === "desktop"}
        onChange={(e) => onChange(value === "mobile" ? "desktop" : "mobile", e)}
      />
      <DashboardIcon size="large" vibe="text-neutral-quiet">
        <Desktop />
      </DashboardIcon>
    </Stack>
  );
};
